var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"context__menu-item"},[_c('a',{staticClass:"context__menu-item-link",class:{
      disabled: !_vm.modelAvailable || !_vm.hasPremium,
      'context__menu-item-link--loading': _vm.loading,
    },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.generateAIFieldValues()}}},[_c('i',{staticClass:"context__menu-item-icon iconoir-magic-wand"}),_vm._v("\n    "+_vm._s(_vm.$t('gridView.generateCellsValues'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }